import UIComponent from "sap/ui/core/UIComponent";
import RouteServices from "niteroi/services/RouteServices";

/**
 * Air Passenger Rights Component
 *
 * @namespace niteroi.packages.air-passenger-rights
 */
export default class Component extends UIComponent {
    public static metadata = {
        interfaces: ["sap.ui.core.IAsyncContentCreation"],
        manifest: "json"
    };
    private _routeServices: RouteServices | undefined;

    public init(): void {
        super.init();
        if (this.getRouter().isInitialized() === false) {
            this._routeServices = new RouteServices(this);
        }
    }

    public getRouteServices(): RouteServices | undefined {
        return this._routeServices;
    }
}
